import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext'; // Make sure to use the correct path
import './css/Login.css';
import API_BASE_URL from './config';

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const { setUser, verifyAuth, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = e => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErrorMessage('');
    try {
      const { data } = await axios.post(`${API_BASE_URL}/api/auth/signin`, credentials, { withCredentials: true });
      setUser(data);
      verifyAuth();
      const role = data.roles.includes('admin') ? '/main-index' : '/dashboard';
      navigate(role);
    } catch (err) {
      const msg = err.response?.data?.message || 'Login failed.';
      setErrorMessage(msg);
    }
  };

  useEffect(() => {
    if (isAuthenticated && location.pathname === '/login') navigate('/dashboard');
  }, [isAuthenticated, location, navigate]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Welcome Back</h2>
        <p>Sign in to continue to PeopleTek 360 Compass</p>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="input-group">
            <label>Username</label>
            <input type="text" name="username" value={credentials.username} onChange={handleChange} required />
          </div>
          <div className="input-group">
            <label>Password</label>
            <input type="password" name="password" value={credentials.password} onChange={handleChange} required />
          </div>
          {errorMessage && <div className="error-message">{errorMessage}</div>}
          <button type="submit" className="auth-button">Login</button>
        </form>
        <div className="auth-footer">
          <span>Don't have an account?</span>
          <a href="/signup">Sign Up</a>
        </div>
      </div>
    </div>
  );
};

export default Login;